module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vregi5-5b48084b0cf3447cbd257ae2f4c86c54.jpg";